import reducer from './reducer'

import * as dealAmendmentsOperations from './operations'
import * as dealAmendmentsSelectors from './selectors'

export { dealAmendmentsOperations, dealAmendmentsSelectors }

export default reducer
